import Chip from "@mui/material/Chip";
import {
  PURCHASE_ORDER_STATUS_LABEL,
  PurchaseOrderStatus,
} from "../../types/purchase-order.type";
import {
  PURCHASE_ORDER_STATUS_COLOR,
  PURCHASE_ORDER_STATUS_OUTLINED,
} from "./data";

interface PurchaseOrderStatusChipProps {
  status: PurchaseOrderStatus;
}

/**
 * สถานะของ PO หนึ่งใบ · ค่าที่แสดงคำนวณจาก backend ตอนอ่านทุกครั้ง จอไม่ตัดสินเอง
 * ใช้ร่วมกันทั้ง W1, W6 และ W7 เพื่อให้คำและสีของสถานะเดียวกันตรงกันทุกจอ
 */
export default function PurchaseOrderStatusChip({
  status,
}: PurchaseOrderStatusChipProps) {
  return (
    <Chip
      size="small"
      label={PURCHASE_ORDER_STATUS_LABEL[status]}
      color={PURCHASE_ORDER_STATUS_COLOR[status]}
      variant={
        PURCHASE_ORDER_STATUS_OUTLINED.has(status) ? "outlined" : "filled"
      }
    />
  );
}
